// import AgoraIOVideoCall from "rc-app/components/Agora";
import MiniDrawer from "rc-app/components/MiniDrawer";
import React, { FC } from "react";

/* The Agora app id used to be read from REACT_APP_ONEVERSE_KEYCLOAK_URL
   here, which was never right — leftover from the prototype below. The
   real one is REACT_APP_AGORA_APP_ID, and the guided-tour room is the
   thing that actually consumes it. Nothing on this page did: the id fed
   only a console.log, which ran on every render because World is the app
   shell. Both gone. */
// const agora_channel = process.env.REACT_APP_AGORA_CHANNEL;
// const agora_token = process.env.REACT_APP_AGORA_TOKEN;
// const agora_token = "007eJxSYDi6wC5wzu8fs4z2qP6yldtYJ+d/hevym/Tv6yPiWzOZXpQqMFgmpZgmmRskWSYZmZuYpphbGhuamRkaJVqkGqYkWhqkHXlbnrqgh4HhlHseEyMDBIL4AgzJGYl5eak58akGlomGppYGDAyAAAAA//+G1CVW"
// const agora_appId= '06be00e80e4644508f42f8bb5f1457d8'
// const agora_channel = 'RL-ESTATE'

export const World: FC<{ Comp: React.ReactNode }> = ({ Comp }) => {
  // const location = useLocation()
  // const queryParams = new URLSearchParams(location.search);
  // const channel = queryParams.get('channel');

  // const [agoraToken, setAgoraToken] = useState()
  // const { email } = UserService.getTokenParsed();
  // const [agoraAppId, setAgoraAppId] = useState();

  // useEffect(() => {
  //   getRtcToken(channel).then((res) => {
  //     setAgoraToken(res.rtcToken)
  //   }).catch(err => console.log('err', err))
  //   getAgoraAppId('RL-ESTATE').then(res => {
  //     setAgoraAppId(res.network['agora_app_id'])
  //   })
  // }, [])

  return (
    <>
      <div className="flex container max-w-screen-2xl">
        <div>
          <MiniDrawer />
        </div>
        <div className="flex-grow pt-[6.6rem]">
          {/* <AgoraIOVideoCall
            token={agoraToken}
            appId={agoraAppId}
            channel={channel}
            userId={email}
          /> */}
          {Comp}
        </div>
      </div>
    </>
  );
};
